"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingCheckboxWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/styles");
var index_1 = require("../../../index");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    Wrap: {
        width: "100%",
        height: 44,
    },
    radioRound: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 44,
        fontWeight: 400,
        fontSize: 16,
    },
    text: {
        color: theme ? theme.app.Setting.color2 : "",
    },
}); });
function SettingCheckboxWrap(props) {
    var children = props.children, onChange = props.onChange, other = tslib_1.__rest(props, ["children", "onChange"]);
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.Wrap },
        react_1.default.createElement("div", { className: classes.radioRound },
            react_1.default.createElement(index_1.Checkbox, tslib_1.__assign({ onChange: onChange }, other)),
            react_1.default.createElement("span", { className: classes.text }, children))));
}
exports.SettingCheckboxWrap = SettingCheckboxWrap;
//# sourceMappingURL=SettingCheckboxWrap.js.map